<template>
  <div class="volume-btn">
    <a class="volume-icon" title="volume-icon">
      <i v-if="volume > 0.5" class="material-icons" @click="updateVolume(0)">
        volume_up
      </i>
      <i v-else-if="volume > 0" class="material-icons" @click="updateVolume(0)">
        volume_down
      </i>
      <i v-else class="material-icons" @click="updateVolume(0.5)">
        volume_off
      </i>
    </a>
    <div ref="volumeProgress" class="volume-progress" @mousedown="progressOnDown">
      <svg :width="width" :height="height" viewbox="0 0 5 84">
        <line class="volume-base" x1="0" y1="5" x2="84" y2="5" />
        <line ref="volumeValue" :class="{muted: volume === 0}" class="volume-value" x1="0" y1="5" x2="84" y2="5" />
      </svg>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PlayerVolumeBtn',
  components: {},
  props: {
    width: {
      type: [Number, String],
      default: 84
    },
    height: {
      type: [Number, String],
      default: 5
    }
  },
  data() {
    return {}
  },
  computed: {
    volume() {
      return this.$store.state.player.volume
    }
  },
  watch: {
    volume(value) {
      // update line volume length
      const percentageLength = `${value * this.width}, ${this.width}` // percentage of progress width
      this.$refs.volumeValue.style.strokeDasharray = percentageLength
    }
  },
  created() {},
  mounted() {},
  updated() {},
  methods: {
    updateVolume(newValue) {
      newValue = newValue > 1 ? 1 : newValue
      newValue = newValue < 0 ? 0 : newValue
      this.$store.commit('SET_PLAYER_VOLUME', newValue)
    },
    progressOnDown(e) {
      this.$refs.volumeProgress.addEventListener('mousemove', this.progressOnMove)
      this.$refs.volumeProgress.addEventListener('mouseup', this.progressOnUp)
    },
    progressOnMove(e) {
      e.stopPropagation()
      e.preventDefault() // prevent other select event!
      this.updateVolume(e.offsetX / this.width)
    },
    progressOnUp(e) {
      this.$refs.volumeProgress.removeEventListener('mousemove', this.progressOnMove)
      this.$refs.volumeProgress.removeEventListener('mouseup', this.progressOnUp)
      this.updateVolume(e.offsetX / this.width)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.volume-btn {
  .volume-icon,
  .volume-progress {
    height: 24px;
    display: inline-block;
    vertical-align: top;
    text-decoration: none;
    cursor: pointer;
  }
  .volume-progress {
    width: 90px; // need to large then progress
    text-align: center;
    position: relative;
    // padding: 9px 0;
    svg{
      position: absolute;
      top: 0;
      bottom: 0;
      left: 5px;
      margin: auto;
    }
    .volume-base {
      fill: none;
      stroke-width: 5;
      stroke: $grey-ec;
      stroke-linecap: round;
    }
    .volume-value {
      fill: none;
      stroke-width: 5;
      stroke: $theme-yellow;
      stroke-linecap: round;
      stroke-dasharray: 0, 0;
    }
    .volume-value.muted {
      stroke: $grey-ec;
    }
  }
}
@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {}

</style>
